import {
  SET_CURRENT_PRESET,

  SET_MIDI_CHANNEL,
  SET_PRESSURE_CC,
  SET_TILT_CC,
  SET_BEND_RANGE_PAD,
  SET_BEND_RANGE_TILT,
  SET_VELOCITY_SENSITIVITY,
  SET_PRESSURE_SENSITIVITY,
  SET_TILT_SENSITIVITY,

  TOGGLE_MPE,
  SET_MPE_MEMBER_CHANNELS,
  
  SET_VELOCITY_CURVE,
  SET_PRESSURE_DISABLED_RETURN,
  SET_TILT_DISABLED_RETURN,
  SET_ON_THRESHOLD,

  REVERT_PRESET,
  REVERT_PREFERENCES,
  REVERT_SENSITIVITIES
} from './actionTypes'

export const setCurrentPreset = (preset) => ({type: SET_CURRENT_PRESET, preset: preset})
export const toggleMPE = () => {
  return (dispatch, getState) => {
    const mpe_active = getState().currentPreset.mpe_active
    dispatch({type: TOGGLE_MPE})
    if(!mpe_active) {
      dispatch(setTiltCC(-1))
    }
  }
}
export const setMPEMemberChannels = (channels) => ({type: SET_MPE_MEMBER_CHANNELS, channels: channels})
export const setMIDIChannel = (channel) => ({type: SET_MIDI_CHANNEL, channel: channel})
export const setPressureCC = (cc) => {
  return (dispatch, getState) => {
    const mpe_active = getState().currentPreset.mpe_active
    dispatch({type: SET_PRESSURE_CC, cc: mpe_active ? -1 : cc})
  }
}
export const setTiltCC = (cc) => {
  return (dispatch) => {
    dispatch({type: SET_TILT_CC, cc: cc})
  }
}

export const setBendRangePad = (range) => ({type: SET_BEND_RANGE_PAD, range: range})
export const setBendRangeTilt = (range) => ({type: SET_BEND_RANGE_TILT, range: range})

export const setVelocitySensitivity = (sensitivity) => ({type: SET_VELOCITY_SENSITIVITY, sensitivity: sensitivity})
export const setPressureSensitivity = (sensitivity) => ({type: SET_PRESSURE_SENSITIVITY, sensitivity: sensitivity})
export const setTiltSensitivity = (sensitivity) => ({type: SET_TILT_SENSITIVITY, sensitivity: sensitivity})

// in preferences
export const setVelocityCurve = (curve) => ({type: SET_VELOCITY_CURVE, curve: curve})
export const setPressureDisabledReturn = (value) => ({type: SET_PRESSURE_DISABLED_RETURN, value: value})
export const setTiltDisabledReturn = (value) => ({type: SET_TILT_DISABLED_RETURN, value: value})
export const setOnThreshold = (threshold) => ({type: SET_ON_THRESHOLD, threshold: threshold})

// reverts
export const revertSettings = (revertType) => {
    let revertingType

    switch (revertType) {
      case 'preset':
        revertingType = REVERT_PRESET
        break;
      case 'preferences':
        revertingType = REVERT_PREFERENCES
        break;
      case 'sensitivities':
        revertingType = REVERT_SENSITIVITIES
        break;
      default:

    }
    return { type: revertingType }
}
